/**
 * « Tes captures » côté navigateur, en attendant l'OIDC (CAP-05).
 *
 * Sans identité serveur, on retient localement les grains capturés depuis CE
 * navigateur (id + titre de secours), du plus récent au plus ancien. Quand
 * l'authentification M365 arrivera, l'attribution passera côté serveur via
 * `Note.authorId` (déjà au schéma) — cette liste deviendra un simple repli.
 */
const KEY = 'gnosis.myCaptures';
const MAX = 50;

export interface MyCaptureRef {
  id: string;
  title: string;
}

export function listMine(): MyCaptureRef[] {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? '[]') as unknown;
    if (!Array.isArray(raw)) return [];
    return raw.filter((x): x is MyCaptureRef => !!x && typeof x.id === 'string');
  } catch {
    return [];
  }
}

function save(refs: MyCaptureRef[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(refs.slice(0, MAX)));
  } catch {
    /* stockage indisponible : la liste reste vide, sans casser la capture */
  }
}

/** Mémorise (ou remonte en tête) un grain capturé/réédité depuis ce navigateur. */
export function rememberCapture(id: string, title: string): void {
  save([{ id, title }, ...listMine().filter((x) => x.id !== id)]);
}

/** Oublie un grain (ex. introuvable côté serveur). */
export function forgetCapture(id: string): void {
  save(listMine().filter((x) => x.id !== id));
}
